import actions from 'actions'

const defaultState = {
  isNewVenue: false,
  newVenue: null,
  newVenueOriginal: null,
  venueSearchResults: null,
  imageId: null,
  isUploadingImage: false,
  isValidatingImage: false,
  imagePreview: null,
  setupformId: null,
  tracked: false,
}

export default function setupformPage(state = defaultState, action) {
  switch (action.type) {
    case actions.SETUPFORM_LOAD:
      return {
        ...state,
        ...defaultState,
        setupformId: action.setupformId,
      }
    case actions.SETUPFORM_SET_IS_NEW_VENUE:
      return {
        ...state,
        isNewVenue: action.isNewVenue,
      }
    case actions.SETUPFORM_SET_NEW_VENUE:
      return {
        ...state,
        newVenue: action.venue,
        newVenueOriginal: action.venue,
      }
    case actions.SETUPFORM_UPDATE_NEW_VENUE:
      return {
        ...state,
        newVenue: state.newVenue ? { ...state.newVenue, ...action.venue } : action.venue,
      }
    case actions.ENTITIES_VENUE_SEARCH_RESULTS.SUCCESS:
      return {
        ...state,
        venueSearchResults: action.response.result.results,
      }
    case actions.SETUPFORM_RESET_VENUE_SEARCH_RESULTS:
      return {
        ...state,
        venueSearchResults: null,
      }
    case actions.SETUPFORM_UPLOAD_IMAGE.REQUEST:
      return {
        ...state,
        isUploadingImage: true,
      }
    case actions.SETUPFORM_UPLOAD_IMAGE.SUCCESS:
      return {
        ...state,
        imageId: action.response.id,
        isUploadingImage: false,
      }
    case actions.SETUPFORM_UPLOAD_IMAGE.FAILURE:
      return {
        ...state,
        isUploadingImage: false,
      }
    case actions.SETUPFORM_DELETE_IMAGE.SUCCESS:
      return {
        ...state,
        imageId: null,
      }
    case actions.SETUPFORM_LOAD_IMAGE.SUCCESS:
      return {
        ...state,
        imageId: action.response[0] ? action.response[0].id : null,
        imagePreview: action.response[0] ? action.response[0].image : null,
      }
    case actions.CROPPER_SELECT:
      return {
        ...state,
        isValidatingImage: true,
      }
    case actions.CROPPER_VALID:
      return {
        ...state,
        isValidatingImage: false,
      }
    case actions.CROPPER_INVALID:
      return {
        ...state,
        isValidatingImage: false,
      }
    case actions.CROPPER_SAVE:
      return {
        ...state,
        imagePreview: action.imagePreview,
      }
    case actions.CROPPER_RESET:
      return {
        ...state,
        imagePreview: null,
      }

    case 'redux-form/FOCUS':
      if (!state.tracked) {
        return {
          ...state,
          tracked: true,
        }
      }
      return state

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/pages/setupform-page/setupform-page.js
 **/